import React from "react";
import { useTranslation } from "react-i18next";

import { HvButton, HvInput } from "@hitachivantara/uikit-react-core";
import { Add } from "@hitachivantara/uikit-react-icons";
import { CameraFilter } from "lib/api";
import { useHistory } from "react-router-dom";
import CameraFilterComponent from "../CameraFilter";

import useStyles from "./styles";

interface TableControls {
  onSearch: (value: string) => void;
  filters?: number[][];
  baseFilter?: CameraFilter[];
  onFilter: (value: number[][]) => void;
  typeId?: string;
  hasInsertUpdateRight: boolean;
}

const CameraTableControls: React.FC<TableControls> = ({
  onSearch,
  filters = [],
  baseFilter = [],
  onFilter,
  hasInsertUpdateRight = false,
}) => {
  const { t } = useTranslation("common");
  const history = useHistory();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HvInput
        className={classes.inputPlaceholder}
        aria-label={t("common:search.ariaLabel")}
        placeholder={t("common:search.placeholder")}
        type="search"
        onEnter={(event, value) => onSearch?.(value)}
      />
      <CameraFilterComponent
        filters={filters}
        baseFilter={baseFilter}
        onChange={onFilter}
      />
      <HvButton
        className={classes.add}
        category="semantic"
        startIcon={<Add />}
        disabled={!hasInsertUpdateRight}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClick={() => history.push(`/settings/camera/add/`)}
      >
        {t("common:buttons.add")}
      </HvButton>
    </div>
  );
};

export default CameraTableControls;
